import { render, staticRenderFns } from "./OrganizationMappingEdit.vue?vue&type=template&id=20eb45e0&scoped=true"
import script from "./OrganizationMappingEdit.vue?vue&type=script&lang=js"
export * from "./OrganizationMappingEdit.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMappingEdit.vue?vue&type=style&index=0&id=20eb45e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb45e0",
  null
  
)

export default component.exports